import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbPagination as ClbPagination_ } from '@celebration/design-system/dist/lib/pagination';
const events = {
    onClbChangePage: ClbPagination_.events
        .onClbChangePage,
    onClbSelectChange: ClbPagination_.events
        .onClbSelectChange,
};
export const ClbPagination = createComponent({
    tagName: ClbPagination_.tagName,
    elementClass: ClbPagination_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map